import React from 'react';
import { Guardian } from '@xaamin/guardian';
import TenancyInfoEnvironment from '../components/TenancyInfoEnvironment';

const TimbradoRetencionInfo = ({ data }) => {
  return (
    <table className="table table-hover">
      <tbody>
        <tr>
          <td className="pr-3">Id</td>
          <td>{ data.id }</td>
        </tr>

        <tr>
          <td className="pr-3">Cliente id</td>
          <td>{ data.cliente_id }</td>
        </tr>

        <tr>
          <td className="pr-3">Empresa id</td>
          <td>{ data.empresa_id }</td>
        </tr>

        { Guardian.allows('root.access') && (
          <tr>
            <td>Pac</td>
            <td>{ data.pac }</td>
          </tr>
        )}

        <tr>
          <td className="pr-3">Idx</td>
          <td>{ data.idx }</td>
        </tr>

        <tr>
          <td className="pr-3">Tenancy</td>
          <td>
            <TenancyInfoEnvironment live={ data.live } />
          </td>
        </tr>

        <tr>
          <td className="pr-3">Status</td>
          <td>{ data.status }</td>
        </tr>

        <tr>
          <td className="pr-3">Code</td>
          <td>{ data.code }</td>
        </tr>

        <tr>
          <td className="pr-3">Reason</td>
          <td>{ data.reason }</td>
        </tr>

        <tr>
          <td className="pr-3">Serie</td>
          <td>{ data.serie }</td>
        </tr>

        <tr>
          <td className="pr-3">Folio</td>
          <td>{ data.folio }</td>
        </tr>

        <tr>
          <td className="pr-3">Servicio</td>
          <td>{ data.servicio }</td>
        </tr>

        <tr>
          <td className="pr-3">Ciudad</td>
          <td>{ data.ciudad }</td>
        </tr>

        <tr>
          <td className="pr-3">Region</td>
          <td>{ data.region }</td>
        </tr>

        <tr>
          <td className="pr-3">Fecha</td>
          <td>{ data.fecha }</td>
        </tr>

        <tr>
          <td className="pr-3">Cveretenc</td>
          <td>{ data.cveretenc }</td>
        </tr>

        <tr>
          <td className="pr-3">Descretenc</td>
          <td>{ data.descretenc }</td>
        </tr>

        <tr>
          <td className="pr-3">Emisor id</td>
          <td>{ data.emisor_id }</td>
        </tr>

        <tr>
          <td className="pr-3">Emisor idx</td>
          <td>{ data.emisor_idx }</td>
        </tr>

        <tr>
          <td className="pr-3">Emisor rfc</td>
          <td>{ data.emisor_rfc }</td>
        </tr>

        <tr>
          <td className="pr-3">Receptor id</td>
          <td>{ data.receptor_id }</td>
        </tr>

        <tr>
          <td className="pr-3">Receptor idx</td>
          <td>{ data.receptor_idx }</td>
        </tr>

        <tr>
          <td className="pr-3">Receptor email</td>
          <td>{ data.receptor_email }</td>
        </tr>

        <tr>
          <td className="pr-3">Receptor nacionalidad</td>
          <td>{ data.receptor_nacionalidad }</td>
        </tr>

        <tr>
          <td className="pr-3">Receptor rfc</td>
          <td>{ data.receptor_rfc }</td>
        </tr>

        <tr>
          <td className="pr-3">Mesini</td>
          <td>{ data.mesini }</td>
        </tr>

        <tr>
          <td className="pr-3">Mesfin</td>
          <td>{ data.mesfin }</td>
        </tr>

        <tr>
          <td className="pr-3">Ejerc</td>
          <td>{ data.ejerc }</td>
        </tr>

        <tr>
          <td className="pr-3">Monto operacion</td>
          <td>{ data.monto_operacion }</td>
        </tr>

        <tr>
          <td className="pr-3">Monto gravado</td>
          <td>{ data.monto_gravado }</td>
        </tr>

        <tr>
          <td className="pr-3">Monto exento</td>
          <td>{ data.monto_exento }</td>
        </tr>

        <tr>
          <td className="pr-3">Monto retenido</td>
          <td>{ data.monto_retenido }</td>
        </tr>

        <tr>
          <td className="pr-3">Metadata</td>
          <td>{ data.metadata }</td>
        </tr>

        <tr>
          <td className="pr-3">Created by</td>
          <td>{ data.created_by }</td>
        </tr>

        <tr>
          <td className="pr-3">Timbrado at</td>
          <td>{ data.timbrado_at }</td>
        </tr>

        <tr>
          <td className="pr-3">Created at</td>
          <td>{ data.created_at }</td>
        </tr>

        <tr>
          <td className="pr-3">Updated at</td>
          <td>{ data.updated_at }</td>
        </tr>

      </tbody>
    </table>
  )
}

export default TimbradoRetencionInfo;